// 详情
<template>
  <div class="form-single-fragment" style="position: relative">
    <el-form
      ref="formData"
      :model="formData"
      class="full-width-input"
      :rules="rules"
      style="width: 100%"
      label-width="100px"
      size="small"
      label-position="right"
      @submit.native.prevent
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="产品编号：" prop="order_no_item">
            <el-input
              v-model="formData.order_no_item"
              placeholder=""
              size="small"
              clearable
              @keyup.enter.native="handlerWidgetInputEnter"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测类型：" prop="processes_id">
            <el-select
              v-model="formData.processes_id"
              placeholder="检测类型"
              clearable
              filterable
              disabled
            >
              <el-option
                v-for="item in processes_idArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="生产车间：" prop="product_line">
            <el-select
              v-model="formData.product_line"
              placeholder="生产车间"
              clearable
              filterable
              disabled
            >
              <el-option
                v-for="item in product_lineArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="生产总线：" prop="product_lineinfo">
            <el-select
              v-model="formData.product_lineinfo"
              placeholder="生产总线"
              clearable
              filterable
              :disabled="len === 1 ? true : false"
            >
              <el-option
                v-for="item in product_lineinfoArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="检测状态：" prop="status">
            <el-radio-group v-model="formData.status">
              <el-radio label="OK">OK</el-radio>
              <el-radio label="NG">NG</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="不合格原因："
            v-if="formData.status === 'NG'"
            prop="reason"
          >
            <el-checkbox-group
              v-model="formData.reason"
              @change="getOtherReasons()"
            >
              <el-checkbox
                v-for="item in reasonArr"
                :key="item.id"
                :label="item.id"
                name="type"
              >
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="other_reasons_show">
          <el-form-item label="其他原因：" prop="other_reasons">
            <el-input
              v-model="formData.other_reasons"
              placeholder=""
              size="small"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="24" v-if="row && !row.id">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button size="small" @click="diaClose" :plain="true">
              取 消
            </el-button>
            <el-button size="small" type="primary" @click="onSave">
              确 认
            </el-button>
          </el-row>
        </el-col> -->
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button size="small" @click="diaClose" :plain="true">
              取 消
            </el-button>
            <el-button size="small" type="primary" @click="onSave">
              确 认
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "LabelModel",
  props: {
    row: Object,
  },
  data() {
    return {
      formData: {
        order_no_item: null,
        processes_id: null,
        product_line: null,
        product_lineinfo: null,
        status: null,
        reason: [],
        other_reasons: null,
      },
      columnArr: [],
      rules: {},

      processes_idArr: [],
      reasonArr: [],
      userArr: [],
      product_lineArr: [
        { id: 1, name: "电气车间" },
        { id: 2, name: "冲压车间" },
        { id: 3, name: "金工车间" },
        { id: 4, name: "总装车间" },
        { id: 5, name: "质检车间" },
        { id: 6, name: "仓库" },
        { id: 7, name: "技术部" },
      ],
      product_lineinfoArr: [
        { id: 1, name: "总装小线" },
        { id: 2, name: "总装中线" },
        { id: 3, name: "总装大线" },
      ],
      len: 1,
      other_reasons_id: null,
      other_reasons_show: false,
    };
  },

  computed: {
    // isEdit () {
    //   return this.postId != null;
    // }
  },
  mounted() {},
  created() {
    if (this.row.id) {
      this.getInfo(this.row.id);
    } else {
      this.selectRole();
    }
    this.getProcesses_idArr();
    // this.getReasonArr();
    this.getUser();
  },
  watch: {},
  methods: {
    getOtherReasons() {
      this.other_reasons_show = this.formData.reason.includes(
        this.other_reasons_id
      );
    },
    async selectRole() {
      const { data } = await this.$api.selectRole();
      this.selectRelationByRoleId(data.data);
    },
    async selectRelationByRoleId(roleId) {
      const { data } = await this.$api.selectRelationByRoleId({ roleId });
      let len = data.productLineinfo.split(",").length;
      this.formData = {
        ...this.formData,
        other_reasons: data.otherReasons,
        processes_id: data.processesId,
        product_line: data.productLine,
        product_lineinfo:
          len === 1
            ? data.productLineinfo.split(",").map((str) => parseFloat(str))[0]
            : null,
      };
      this.len = len;
      this.getReasonArr(data.processesId);
    },
    handlerWidgetInputEnter(e) {
      console.log(e.target.value);
      console.log("handlerWidgetInputEnter", e);
      // this.$emit("EnterInput", e.target.value);
    },
    // 新增质检查询 接口
    async selectQuality(params) {
      let _this = this;
      let { data } = await this.$api.selectQuality(params);
      console.log("data", data);
      // this.onCancel(true); // 刷新列表
      if (data) {
        _this.$message("该产品当前工序已质检合格");
      } else {
        _this.addQualityInspect(params);
      }
    },
    // 新增品质质检
    onQuality() {
      let _this = this;
      console.log("新增品质质检 _this.formData", _this.formData);
      let params = {
        orderNoItem: _this.formData.order_no_item,
        // orderType: _this.formData.order_type,
        processesId: _this.formData.processes_id,
        productLine: _this.formData.product_line,
        status: _this.formData.status,
        reason: _this.formData.reason.join(","),
        productLineinfo: _this.formData.product_lineinfo,
        otherReasons: _this.formData.other_reasons,
      };
      if (this.row.id) {
        _this.updateQMS(params);
      } else {
        _this.selectQuality(params);
      }
    },
    // 新增品质质检 接口
    async addQualityInspect(params) {
      await this.$api.addQualityInspect(params);
      this.formData.order_no_item = null;
      this.formData.status = null;
      this.formData.reason = [];
      this.formData.other_reasons = null;
      this.other_reasons_show = false;
      this.$message.success("质检并自动报工成功");
      this.$emit("getTableData");
    },
    // 质检修改并撤回报工 接口
    async updateQMS(params) {
      await this.$api.updateQMS(params);
      this.formData.order_no_item = null;
      this.formData.status = null;
      this.formData.reason = [];
      this.formData.other_reasons = null;
      this.other_reasons_show = false;
      this.$message.success("质检修改成功");
      this.$emit("getTableData");
    },
    getInfo(dataId) {
      let params = {
        datasourceId: "1642727793923985408",
        dataId,
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/viewByDatasourceId/" + "dsQmsHistory",
        "get",
        params
      );
      httpCall.then((res) => {
        this.formData = {
          ...res.data,
          reason: res.data.reason.split(",").map((str) => parseFloat(str)),
        };
        if (this.formData.other_reasons) this.other_reasons_show = true;
        this.getReasonArr(this.formData.processes_id);
      });
    },
    getProcesses_idArr() {
      let params = {
        dictId: "1653768968319537152",
        filterDtoList: [
          { filterType: 4, columnName: "id", columnValueList: [2, 4] },
        ],
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.processes_idArr = res.data;
      });
    },
    getReasonArr(processesId) {
      // 2，4
      let params = {
        dictId: "1710921716768706560",
        filterDtoList: [
          { columnName: "type", columnValue: processesId, filterType: 1 },
        ],
      };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.reasonArr = res.data;
        this.other_reasons_id = this.reasonArr[this.reasonArr.length - 1].id;
      });
    },
    getUser() {
      let params = { dictId: "1440944417170001920", filterDtoList: [] };
      let httpCall = this.doUrl(
        "/admin/online/onlineOperation/listDict",
        "post",
        params
      );
      httpCall.then((res) => {
        this.userArr = res.data;
      });
    },
    onSave() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.onQuality();
        } else {
          this.$message("请填写完整");
          return false;
        }
      });
    },
    diaClose() {
      this.$emit("diaClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.Subtable {
  padding: 0 25px;
  box-sizing: border-box;
}
</style>
<style>
.el-table td > .cell span {
  display: inline-block !important;
}
::v-deep .el-radio__input {
  display: inline-block !important;
}
</style>
